// Lead pipeline stages
export type LeadStatus =
  | "new"
  | "contacted"
  | "in_conversation"
  | "qualified"
  | "converted"
  | "deleted";

// Ordered list for cycling through stages
export const LEAD_STATUS_ORDER: LeadStatus[] = [
  "new",
  "contacted",
  "in_conversation",
  "qualified",
  "converted",
];

// Lead entity returned by the server
export interface Lead {
  id: string;
  searchId: string;
  companyName: string;
  companyUrl: string;
  companyDescription: string;
  contactName: string;
  contactEmail: string;
  contactPhone?: string;
  contactTitle: string;
  location: string;
  matchConfidence: "high" | "medium" | "low";
  linkedinUrl: string;
  status: LeadStatus;
  isPreview: boolean;
  createdAt: string;
}

// A search query run by the founder
export interface LeadSearch {
  id: string;
  query: string;
  status: "generating" | "previewing" | "preview_ready" | "running" | "completed" | "failed";
  matchLimit: number;
  totalGenerated: number;
  totalMatched: number;
  creditsCharged: number;
  duplicatesSkipped: number;
  error?: string;
  createdAt: string;
  completedAt?: string;
}

// Status polling response (subset of LeadSearch)
export interface SearchStatusResponse {
  id: string;
  status: LeadSearch["status"];
  totalGenerated: number;
  totalMatched: number;
  creditsCharged: number;
  duplicatesSkipped: number;
  error?: string;
}

// Steps in the new search flow
export type SearchFlowStep =
  | "suggestion" // AI generates a suggested query
  | "preview" // Show 5-10 preview results
  | "confirm" // Confirm to run full search
  | "running" // Full search is running
  | "complete"; // Search finished

export interface SearchFlowState {
  step: SearchFlowStep;
  suggestedQuery: string;
  editedQuery: string;
  previewLeads: Lead[];
  fullSearchLeadCount: number;
}
